import React from "react";
import {
  getProductRating,
  getProductReviewsCount,
  safeNumber,
} from "../utils/productSorting";
import styles from "./ProductRatingSummary.module.css";

const STAR_SYMBOLS = "★★★★★";

const pluralizeReviews = (count) => {
  const value = Math.abs(Math.trunc(safeNumber(count)));
  const lastTwo = value % 100;
  const last = value % 10;

  if (lastTwo >= 11 && lastTwo <= 14) return "відгуків";
  if (last === 1) return "відгук";
  if (last >= 2 && last <= 4) return "відгуки";
  return "відгуків";
};

const ProductRatingSummary = ({
  product,
  className = "",
  compact = false,
}) => {
  const ratingValue = Math.min(
    5,
    Math.max(0, Math.round(safeNumber(getProductRating(product)) * 10) / 10),
  );
  const reviewsCount = Math.max(
    0,
    Math.round(safeNumber(getProductReviewsCount(product))),
  );
  const rowClassName = [
    styles.ratingRow,
    compact ? styles.compact : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (ratingValue <= 0 || reviewsCount <= 0) {
    return null;
  }

  return (
    <div
      className={rowClassName}
      aria-label={`Рейтинг ${ratingValue.toFixed(1)} з 5, ${reviewsCount} ${pluralizeReviews(
        reviewsCount,
      )}`}
      >
        <span className={styles.ratingStars} aria-hidden="true">
        <span className={styles.ratingStarsBase}>{STAR_SYMBOLS}</span>
        <span
          className={styles.ratingStarsFill}
          style={{ width: `${(ratingValue / 5) * 100}%` }}
        >
          {STAR_SYMBOLS}
        </span>
      </span>
      <span>
        {ratingValue.toFixed(1)} ({reviewsCount} {pluralizeReviews(reviewsCount)})
      </span>
    </div>
  );
};

export default ProductRatingSummary;
